import { useMemo } from 'react';
import { getLocale } from './locale';

export function useLocale(): string {
  return useMemo(() => getLocale(), []);
}

